import {useCallback, useMemo, useState} from 'react';
//import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the Data Grid
import "ag-grid-community/styles/ag-theme-quartz.css";
import "ag-grid-community/styles/ag-theme-balham.css"
import '../../components/TablaMaestra.css'
import { ModuleRegistry } from '@ag-grid-community/core';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import {ExcelExportModule, MenuModule, RowGroupingModule, SetFilterModule, FiltersToolPanelModule} from "ag-grid-enterprise";
import { fetchColumnDefinitions, fetchFilteredData } from '../../services/tablaMaestraService'
import MaestraOpcionesToolPanel from '../../components/aggrid/MaestraOpcionesToolPanel';
import DetalleMaestraEditar from '../../components/claim/DetalleQuickView';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button } from '@heroui/react';

ModuleRegistry.registerModules([
    ClientSideRowModelModule,
    ColumnsToolPanelModule,
    FiltersToolPanelModule,
    MenuModule,
    RowGroupingModule,
    SetFilterModule,
    ExcelExportModule
]);

function TablaMaestra({ darkMode }) {
    // Row Data: The data to be displayed.
    const [rowData, setRowData] = useState();

    // Column Definitions: Defines the columns to be displayed.
    const [colDefs, setColDefs] = useState([]);

    const [showEditarMaestra, setShowEditarMaestra] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [gridApi, setGridApi] = useState(null);

    const defaultColDef = useMemo(() => {
        return {
            filter: 'agTextColumnFilter',
            floatingFilter: true,
        };
    }, []);
    const rowSelection = "single";

    const getRowId = useCallback((params) => params.data.mr_id, []);

    const onCellEditRequest = useCallback(async (event) => {
        const oldData = event.data;
        const field = event.colDef.field; //Column
        const newValue = event.newValue; //Value
        const newData = { ...oldData };
        const dataToUpdate = { 'id': newData.id, 'column': field, 'newValue': newValue, 'oldValue': event.oldValue }
        newData[field] = event.newValue;
        console.log("onCellEditRequest, updating " + field + " to " + newValue);
        console.log("Data to update: ", dataToUpdate);
        console.log("event: ", event);

        //undefined deberia hacer un return

        try {
            // SEND POST REQUEST
            const response = await fetch('https://quickview.rskgroupco.com/app/judicial/updateone', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dataToUpdate),
            });

            // HANDLE RESPONSE
            if (response.ok) {
                const updatedData = await response.json(); // Si el servidor devuelve datos
                console.log("Actualización exitosa", updatedData);

                // APPLY AGGRID TX
                const tx = {
                    update: [newData],
                };
                event.api.applyTransaction(tx);

            } else {
                const errorText = await response.text();
                console.error("Error en el servidor: ", errorText);
                alert("Error al actualizar el dato: " + errorText);
            }

        } catch (error) {
            console.error("Error al enviar la solicitud: ", error);
            alert("Error al conectar con el servidor.");
        }

    }, []);

    const getMoneySymbolByColumn = (columnName) => {
        let symbol;
        switch(columnName){
            case 'mr_monto_indemnizado_usd':
            case 'mr_reclamo_usd':
            case 'mr_expectativas_usd':
            case 'mr_recuperado_usd':
                symbol = '$';
                break;

            case 'mr_reclamo_euros':
            case 'mr_recuperado_euros':
                symbol = '€';
                break;

            default:
                symbol = '';
                break;
        }
        return symbol
    }

    const editableColumns = [
        'mr_comentario',
        'mr_reclamo_a_terceros',
        'mr_monto_indemnizado_usd',
        'mr_deducible',
        'mr_claudio',
        'mr_reclamo_usd',
        'mr_reclamo_euros',
        'mr_expectativas_usd',
        'mr_recuperado_usd',
        'mr_recuperado_euros',
        'mr_status'
    ];

    const setColumTypeFromPostgresTableDefinition = (column) => {
        // Procesar el headerName
        const headerName = column.column_name.includes('_')
            ? column.column_name.split('_') // Divide por '_'
                .slice(1) // Toma todo después del primer '_'
                .map((word, index) =>
                    index === 0
                        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() // Primera palabra capitalizada
                        : word.toLowerCase() // Siguientes palabras en lowercase
                )
                .join(' ') // Une sin separadores
            : column.column_name;
        

        
        //console.log("type: " + column.column_name);
        //console.log("column data: ", column)

        let colData = {
            //columnGroupShow: 'open',
            headerName: headerName
        };
        
        switch(column.data_type){
            case "uuid":
                if(column.column_name === "mr_id" || column.column_name === "mj_maestra_recuperos_id"){
                    colData = {
                        ...colData,
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        hide: true,
                        suppressColumnsToolPanel: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        }
                    };
                }else{
                    colData = {
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                    };
                }

                break;
            case "timestamp without time zone":
            case "timestamp with time zone": //ambos timestamp
            case "date":
                colData =
                    {
                        ...colData,
                        field: column.column_name, cellEditor: 'agDateCellEditor', editable: editableColumns.includes(column.column_name),
                        filter: 'agDateColumnFilter',
                        valueGetter: (params) => {
                            //Convertir a fecha de JS
                            return params.data && params.data[column.column_name] ? new Date(params.data[column.column_name]) : null;
                        },
                        valueFormatter: (params) => {
                            // Formatea la fecha para mostrarla como texto en la celda
                            return params.value ? params.value.toLocaleDateString() : '';
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    };

                break;
            case "character varying": //character_maximum_length: 255
                if(column.column_name === "status"){
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agSelectCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            values: ['Ready to Claim', 'Juicio Chile', 'Juicio Perú', 'Finiquito Firmado', 'Reclamado', 'Cerrado',],
                            //valueListMaxHeight: 120,
                            //valueListMaxWidth: 120,
                            maxLength: column.character_maximum_length
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                } else {
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agTextCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            maxLength: column.character_maximum_length
                        },
                        sort: column.column_name === 'rsk_ref_number' ? 'desc' : false,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    }
                }
                break;
            case "text": //no character limit
                if(column.column_name === "mr_dias_que_faltan") {
                    // Caso especial para la columna de días que faltan
                    colData = {
                        ...colData,
                        field: column.column_name,
                        // valueGetter para ordenamiento numérico
                        valueGetter: (params) => {
                            const value = params.data && params.data[column.column_name];
                            if (!value || value === "N/A") return 999999; // N/A va al final
                            if (value === "Vencido") return 999998; // Vencido va antes que N/A
                            const num = parseInt(value);
                            return isNaN(num) ? 999999 : num; // Números normales para ordenamiento
                        },
                        // valueFormatter para mostrar el texto original
                        valueFormatter: (params) => {
                            return params.data && params.data[column.column_name] ? params.data[column.column_name] : '';
                        },
                        cellClassRules: {
                            'dias-critico': (params) => {
                                const dias = params.data && params.data[column.column_name];
                                if (dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum <= 30;
                            },
                            'dias-advertencia': (params) => {
                                const dias = params.data && params.data[column.column_name];
                                if (dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum > 30 && diasNum <= 60;
                            },
                            'dias-normal': (params) => {
                                const dias = params.data && params.data[column.column_name];
                                if (dias === "N/A" || dias === "Vencido") return false;
                                const diasNum = parseInt(dias);
                                return !isNaN(diasNum) && diasNum > 60;
                            },
                            'dias-vencido': (params) => {
                                const dias = params.data && params.data[column.column_name];
                                return dias === "N/A" || dias === "Vencido";
                            }
                        },
                        sortable: true,
                        // sort: 'desc', // Ordenar por defecto de mayor a menor
                        filter: true,
                        enableRowGroup: true,
                        enablePivot: true,
                        width: 120
                    };
                } else {
                    colData = {
                        ...colData,
                        field: column.column_name, cellEditor: 'agLargeTextCellEditor', editable: editableColumns.includes(column.column_name),
                        cellEditorPopup: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableRowGroup: true,
                        enablePivot: true,
                    };
                }
                break;
            case "smallint": //numeric_precision: 16 (smallint = 16) / numeric_scale (normally numeric scale for smallint is 0)
            case "integer": //numeric_precision: 32 (int32) / numeric_scale both integers (normally numeric scale for integer is 0)
                if(column.column_name === "mj_id"){
                    colData = {
                        ...colData,
                        field: column.column_name, editable: editableColumns.includes(column.column_name),
                        hide: true,
                        suppressColumnsToolPanel: true,
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        }
                    };
                }else {
                    colData = {
                        ...colData,
                        field: column.column_name,
                        cellEditor: 'agNumberCellEditor',
                        editable: editableColumns.includes(column.column_name),
                        cellEditorParams: {
                            min: -Math.pow(10, column.numeric_precision) + 1,
                            max: Math.pow(10, column.numeric_precision) - 1
                        },
                        valueGetter: params => {
                            const value = params.data && params.data[column.column_name];
                            // Si el valor es nulo, undefined, o una cadena vacía, devolver null
                            if (value === null || value === undefined || value === '') {
                                return null;
                            }
                            const num = Number(value);
                            return isNaN(num) ? null : num;
                        },
                        valueFormatter: (params) => {
                            // Si el valor es nulo o undefined, mostrar vacío
                            if (params.value === null || params.value === undefined) {
                                return '';
                            }
                            // Si el valor es 0, mostrarlo normalmente
                            return params.value.toString();
                        },
                        cellClassRules: {
                            'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                        },
                        enableValue: true,
                    }
                }

                break;
            case "numeric": //numeric_precision / numeric_scale both integers
                // Cálculo del rango
                const max = Math.pow(10, column.numeric_precision - column.numeric_scale) - Math.pow(10, -column.numeric_scale); // Máximo positivo
                const min = -max; // Mínimo negativo
                colData = {
                    ...colData,
                    field: column.column_name, cellEditor: 'agNumberCellEditor', editable: editableColumns.includes(column.column_name),
                    cellEditorParams: {
                        min: min,
                        max: max,
                        precision: column.numeric_scale
                        //step: Math.pow(10, -column.numeric_scale), // Incremento basado en la escala
                    },
                    valueFormatter: (params) => {
                        // Si el valor es nulo o undefined, mostrar vacío
                        if (params.value === null || params.value === undefined) {
                            return '';
                        }
                        // Si el valor es 0, mostrarlo normalmente
                        return `${getMoneySymbolByColumn(column.column_name)} ${Number(params.value).toFixed(column.numeric_scale)}`;
                    },
                    valueGetter: params => {
                        const value = params.data && params.data[column.column_name];
                        // Si el valor es nulo, undefined, o una cadena vacía, devolver null
                        if (value === null || value === undefined || value === '') {
                            return null;
                        }
                        const num = Number(value);
                        // Si el número es 0, verificar si realmente es 0 o si era nulo
                        if (num === 0 && (value === null || value === undefined || value === '')) {
                            return null;
                        }
                        return isNaN(num) ? null : num;
                    },
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                    //enableRowGroup: true,
                    //enablePivot: true,
                    enableValue: true,
                };

                break;
            default:
                colData = {
                    ...colData,
                    field: column.column_name, editable: editableColumns.includes(column.column_name),
                    cellClassRules: {
                        'non-editable-cell': (params) => !params.colDef.editable, // Aplica la clase si no es editable
                    },
                };
                break;
        }

        return colData;
    }

    const onGridReady = useCallback(async (params) => {

        try {
            // Obtener definición de columnas
            const columnDefinitions = await fetchColumnDefinitions();
            const colDefs = columnDefinitions.map(setColumTypeFromPostgresTableDefinition);

            const tabla_maestra = colDefs.filter((row) =>
                row.field.split('_')[0] === "mr"
            );
            const tabla_judicial = colDefs.filter((row) =>
                row.field.split('_')[0] === "mj"
            );

            const columnDefs = [
                {
                    headerName: 'Tabla Maestra',
                    children: tabla_maestra
                },
                {
                    headerName: 'Tabla Judicial',
                    children: tabla_judicial
                }
            ]
            setColDefs(columnDefs)

            // Obtener datos filtrados
            const rowData = await fetchFilteredData();
            

            
            setRowData(rowData);
        } catch (error) {
            console.error('Error al cargar los datos:', error);
        }
        setGridApi(params.api);
    }, []);

    const handleEditarMaestra = (row) => {
        setSelectedRow(row);
        setShowEditarMaestra(true);
    };

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel"
            },
            {
                id: "options",
                labelDefault: "Options",
                iconKey: "options",
                toolPanel: MaestraOpcionesToolPanel,
                toolPanelParams: {
                    api: gridApi,
                    onEditarMaestra: handleEditarMaestra
                }
            }
        ],
        defaultToolPanel: "columns"
    }), [gridApi]);

    return (
        <div
            className={`${darkMode ? "ag-theme-balham-dark" : "ag-theme-balham"} h-[calc(100vh-64px)] w-full`}
        >
            <AgGridReact
                rowData={rowData}
                columnDefs={colDefs}
                defaultColDef={defaultColDef}
                rowSelection={rowSelection}
                getRowId={getRowId}
                readOnlyEdit={true}
                onCellEditRequest={onCellEditRequest}
                sideBar={sideBar}
                onGridReady={onGridReady}
            />
            <Modal isOpen={showEditarMaestra} onClose={() => setShowEditarMaestra(false)}>
                <ModalHeader>Editar Tabla Maestra</ModalHeader>
                <ModalBody>
                    <DetalleMaestraEditar maestraData={selectedRow || {}} />
                </ModalBody>
                <ModalFooter>
                    <Button color="danger" variant="light" onPress={() => setShowEditarMaestra(false)}>
                        Cerrar
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default TablaMaestra;